import * as utils from "./LocalStorageHelpers";

const localStorageLastLocationKey = "metronic-lastLocation";

function acceptLocation(lastLocation) {
  if (
    lastLocation &&
    lastLocation.pathname &&
    lastLocation.pathname !== "/" &&
    lastLocation.pathname.indexOf("auth") === -1 &&
    lastLocation.pathname !== "/logout"
  ) {
    return true;
  }

  return false;
}

export function saveLastLocation(lastLocation) {
  if (acceptLocation(lastLocation)) {
    utils.setStorage(
      localStorageLastLocationKey,
      JSON.stringify(lastLocation),
      120
    );
  }
}

export function forgotLastLocation() {
  utils.removeStorage(localStorageLastLocationKey);
}

export function getLastLocation() {
  const defaultLocation = { pathname: "/", title: "Dashboard" };
  const localStorateLocations = utils.getStorage(localStorageLastLocationKey);
  if (!localStorateLocations) {
    return { pathname: "/", title: "Dashboard" };
  }

  try {
    const result = JSON.parse(localStorateLocations);
    return result;
  } catch (error) {
    console.error(error);
    return defaultLocation;
  }
}

export function getCurrentUrl(location) {
  return location.pathname.split(/[?#]/)[0];
}

export function checkIsActive(location, url, exactMatch = false) {
  const current = getCurrentUrl(location);
  if (!current || !url) {
    return false;
  }

  // Exact match check
  if (current === url) {
    return true;
  }

  // For exact match mode, only return true if URLs match exactly
  if (exactMatch) {
    return false;
  }

  // Check if current path starts with url and is followed by / or nothing
  // This prevents /stakeholder/cabinet/events from matching /stakeholder/cabinet/event
  if (current.startsWith(url)) {
    const remainder = current.slice(url.length);
    // Must be exact match or followed by /
    if (remainder === "" || remainder.startsWith("/")) {
      return true;
    }
  }

  return false;
}

// Check if any of the child URLs match the current location
export function checkIsActiveForChildren(location, childUrls) {
  if (!childUrls || !Array.isArray(childUrls)) {
    return false;
  }
  return childUrls.some((url) => checkIsActive(location, url));
}
